export const MastercardLogo = ({ className = "h-8 w-auto" }) => (
  <svg
    viewBox="0 0 48 30"
    className={className}
    role="img"
    aria-label="Mastercard"
  >
    <circle cx="18" cy="15" r="11" fill="#EB001B" />
    <circle cx="30" cy="15" r="11" fill="#F79E1B" />
    <path
      d="M24 7.8a11 11 0 0 0 0 14.4a11 11 0 0 0 0-14.4z"
      fill="#FF5F00"
    />
  </svg>
);
